<script>
import { computed, Suspense } from "vue";
import { useRoute } from "vue-router";
import AdvancedCourseOverview from "./AdvancedCourseOverview/AdvancedCourseOverview.vue";

const AdvancedCourseParent = {
    name: "AdvancedCourseParent",
    props: {},
    components: { Suspense, AdvancedCourseOverview },
    setup() {
        const route = useRoute();
        const termdate = computed(() => route.params.termdateId);

        return {
            termdate,
        };
    },
};

export default AdvancedCourseParent;
</script>

<template>
    <Suspense>
        <AdvancedCourseOverview :termdate-id="termdate"/>
        <template #fallback>
            Loading...
        </template>
    </Suspense>
</template>

<style scoped>

</style>
